import React from "react";
import LazyComponent from "../LazyComponent";

const StageController = ({ stage, stages }) =>
  Object.entries(stages).map(([key, Component]) => {
    if (!(Component instanceof LazyComponent))
      return <Component key={key} isActive={stage === key} />;
    return null;
  });

export default StageController;
